export const MAX_IMAGE_HEIGHT = 300; // maximum height for images (in pixels)
export const WIDTH_BREAKPOINT = 1000; // breakpoint (in px) for alternating two-column layout
export const MAX_IMAGES_ALLOWED = 4; // maximum number of images per fragment